<!-- Form -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2">
      <!-- Label -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.content"
        label="global.question_text"
        placeholder="global.question_text"
      (valueChange)="onSubmit()"></medsurf-editor>
      <!-- Choices -->
      <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 mb-2 drag-node">
        <span class="white-space-nowrap overflow-hidden text-overflow-ellipsis mb-2">
          {{ 'global.choices' | translate }}:
        </span>
        <div class="flex flex-column row-gap-2">
          @if (trainingSharedFacade.choicesByIds$(question.choices) | async | sortBy_shared:'asc':'order'; as choices) {
            <div class="flex flex-column row-gap-2"
              [dragula]="getDragulaKey('choices')"
              [dragulaModel]="choices"
              (dragulaModelChange)="onChoiceMoved($event)">
              @for (choice of choices; track trackBy(j, choice); let j = $index) {
                <div class="flex flex-grow-1 flex-shrink-1 flex-column row-gap-1 drag-node">
                  <div class="flex flex-grow-1 flex-row column-gap-2 align-items-center h-row border-round hover:surface-hover cursor-pointer">
                    <div class="flex w-2rem">
                      <button medsurf-design-input-button [id]="'choice_handle_' + choice.id"
                        [title]="'global.choice_handle' | translate"
                        [class]="'handle cursor-move'"
                        [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.HANDLE_OUTLINED_WHITE"
                      [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.MOVE"></button>
                    </div>
                    <medsurf-quiz-single-choice-question-choice [class]="'w-full'"
                      [question]="question"
                      [choice]="choice"
                      [index]="j"
                      [solution]="form.value.solution || 0"
                    (solutionChange)="onSolutionChange($event)"></medsurf-quiz-single-choice-question-choice>
                  </div>
                </div>
              }
            </div>
          }
          @if (question.type === FlatModels.QuestionEntityModels.QuestionType.enum.LongListQuestion) {
            <button medsurf-design-input-button
              [id]="'single_choice_choice_add'"
              [title]="'global.choice_add' | translate"
              class="align-self-start"
              [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_OUTLINED"
              [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
            (click)="addChoice()"></button>
          }
        </div>
      </div>
      <!-- Explanation -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.explanation"
        label="global.explanation_text"
        placeholder="global.explanation_text_description"
      (valueChange)="onSubmit()"></medsurf-editor>
    </div>
  </medsurf-design-form-control-form>
}